import { getSourcingView } from '../../utils/sidebarPreferences';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { onValue, ref } from 'firebase/database';
import { database } from '../../firebase';
import { useAuth } from '../../contexts/AuthContext';
import { useLanguage } from '../../contexts/LanguageContext';
import useCompanyUID from '../../hooks/useCompanyUID';
import TalentSearch from '../TalentSearch/TalentSearch';
import TalentAgent from './TalentAgent';
import './TalentAgent.css';

export default function SourcingWorkspace({ tutorialActive }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { language } = useLanguage();
  const { currentUser } = useAuth();
  const { companyUID, loading: companyLoading } = useCompanyUID();
  const [agentFlag, setAgentFlag] = useState(null);
  const userUid = currentUser?.uid;
  // Frontend rollout flag. Missing, unreadable or non-boolean values keep the
  // existing Search-only view. Never mount Agent before this account opts in.
  useEffect(() => {
    if (companyLoading || !companyUID || !userUid) return undefined;
    let cancelled = false;
    const updateFlag = enabled => {
      if (!cancelled) setAgentFlag({ companyUID, userUid, enabled });
    };
    const unsubscribe = onValue(ref(database, `companies/${companyUID}/featureFlags/talentAgent`),
      snapshot => updateFlag(snapshot.val() === true), () => updateFlag(false));
    return () => { cancelled = true; unsubscribe(); };
  }, [companyUID, companyLoading, userUid]);
  const agentEnabled = !companyLoading && !!userUid && agentFlag?.companyUID === companyUID &&
    agentFlag?.userUid === userUid && agentFlag?.enabled === true;
  const [tab, setTab] = useState(location.state?.searchState?.agentRunId || location.state?.searchState?.sourcingMode === 'agent' ? 'agent' : 'search');
  const shortlistView = getSourcingView(location.search) === 'shortlists';
  useEffect(() => {
    if (location.state?.searchState?.sourcingMode === 'agent' && getSourcingView(location.search) === 'search') setTab('agent');
    else if (getSourcingView(location.search)) setTab('search');
  }, [location.search, location.key, location.state, shortlistView]);
  const active = tutorialActive || !agentEnabled || shortlistView ? 'search' : tab;
  const arabic = language === 'ar';
  return <div className="sourcing-workspace">
    {agentEnabled && !shortlistView && <div className="sourcing-mode-tabs" role="tablist" aria-label={arabic ? 'طريقة البحث' : 'Sourcing mode'}>
      {['search', 'agent'].map((mode) => <button key={mode} id={`sourcing-tab-${mode}`}
        role="tab" aria-selected={active === mode} aria-controls={`sourcing-panel-${mode}`}
        tabIndex={active === mode ? 0 : -1} onClick={() => setTab(mode)}
        onKeyDown={(event) => {
          if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
            event.preventDefault();
            const next = event.key === 'Home' ? 'search' : event.key === 'End' ? 'agent' : active === 'search' ? 'agent' : 'search';
            setTab(next); document.getElementById(`sourcing-tab-${next}`)?.focus();
          }
        }}>
        <i aria-hidden="true" className={`fa-solid ${mode === 'search' ? 'fa-magnifying-glass' : 'fa-wand-magic-sparkles'}`} />
        {mode === 'search' ? (arabic ? 'البحث' : 'Search') : (arabic ? 'الوكيل' : 'Agent')}
      </button>)}
    </div>}
    {/* Enabled accounts keep both modes mounted when switching tabs. */}
    <div role={agentEnabled && !shortlistView ? 'tabpanel' : undefined} id="sourcing-panel-search" aria-labelledby={agentEnabled && !shortlistView ? 'sourcing-tab-search' : undefined} hidden={active !== 'search'}>
      <TalentSearch />
    </div>
    {agentEnabled && <div role="tabpanel" id="sourcing-panel-agent" aria-labelledby="sourcing-tab-agent" hidden={active !== 'agent'}>
      <TalentAgent onOpenShortlists={searchState => navigate('/sourcing?view=shortlists', { state: { searchState } })} />
    </div>}
  </div>;
}
